import React from "react"
import { defineMessages, useIntl } from "react-intl"
import _ from "lodash"
// Material UI
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import { words } from "../../i18n/lstrings"

const img = require("../../styles/img/authentification.png")

const messages = defineMessages({
  registerConfirmTitle: {
    defaultMessage: "Your account has been created",
    id: "register.confirm.title"
  },
  registerConfirmText: {
    defaultMessage:
      "However this requires the {activation} of an administrator, which will take place within 48 hours.",
    id: "register.confirm.text"
  },
  registerConfirmActivation: {
    defaultMessage: "activation",
    id: "register.confirm.activation"
  },
  registerConfirmTextB: {
    defaultMessage:
      "You will receive an {email} when your account is activated.",
    id: "register.confirm.textb"
  }
})

const boldifyText = (text) => <b key="boldish-text"> {text} </b>

const RegisterConfirmPage = () => {
  const { formatMessage: format } = useIntl()

  const activationWord = format(messages.registerConfirmActivation)
  const emailWord = _.toLowerCase(format(words.email))
  return (
    <Box className="register-confirm-page">
      <img src={img} alt="Authentification" />
      <h1 className="display-1">{format(messages.registerConfirmTitle)}</h1>
      <Typography>
        {format(messages.registerConfirmText, {
          activation: boldifyText(activationWord)
        })}
      </Typography>
      <Typography>
        {format(messages.registerConfirmTextB, {
          email: boldifyText(emailWord)
        })}
      </Typography>
    </Box>
  )
}

export default RegisterConfirmPage
